import { computed } from 'vue';
import networkStateStore from './network-state-store';

const useNetworkState = () => {
  const store = networkStateStore();

  return {
    isInitialised: computed(() => store.isInitialised),
    isOnline: computed(() => store.isOnline),
  };
};

export default useNetworkState;
